<div
  class="uff"
  [class.uff--rejected]="item.status === 'REJECTED'"
  [class.uff--approved]="item.status === 'APPROVED'"
  [class.uff--submitted]="item.status === 'SUBMITTED'"
>
  <div class="uff__header">
    <label class="uff__label">{{ label }}</label>
    <span
      class="uff__chip"
      [style.background]="statusColor(item.status) + '22'"
      [style.color]="statusColor(item.status)"
      [style.border-color]="statusColor(item.status) + '55'"
    >
      {{ statusLabel(item.status) }}
    </span>
  </div>

  <!-- Drop zone vacío: dos caminos — tomar foto con cámara o subir archivo -->
  <div
    *ngIf="!showPreviewArea && uploadState === 'idle'"
    class="uff__actions"
    [class.uff__actions--disabled]="!canUpload"
  >
    <button
      type="button"
      class="uff__camera-btn"
      (click)="openCamera()"
      [disabled]="!canUpload"
    >
      <mat-icon>photo_camera</mat-icon>
      <div>
        <span class="uff__camera-btn-title">Tomar foto con la cámara</span>
        <span class="uff__camera-btn-hint">Recomendado desde tu celular</span>
      </div>
    </button>

    <button
      type="button"
      class="uff__dropzone"
      [class.uff__dropzone--disabled]="!canUpload"
      [disabled]="!canUpload"
      (click)="triggerInitialFileInput()"
    >
      <mat-icon>upload_file</mat-icon>
      <span class="uff__dropzone-title">Subir desde archivo</span>
      <span class="uff__dropzone-hint">JPG, PNG, WEBP o PDF · máx 10 MB</span>
    </button>
    <!-- Input file oculto — se dispara con .click() desde el botón. HTML
         no permite <input> como hijo de <button>; lo dejamos como sibling
         para que el DOM sea válido. -->
    <input
      #initialFileInput
      type="file"
      [accept]="acceptAttr"
      [disabled]="!canUpload"
      (change)="onFileSelected($event)"
      class="uff__file-input"
    />
  </div>

  <!-- Preview con archivo subido (remoto o local) -->
  <div *ngIf="showPreviewArea" class="uff__preview-area">
    <div class="uff__preview">
      <img
        *ngIf="localPreview"
        [src]="localPreview"
        alt="Vista previa"
        class="uff__preview-img"
      />
      <img
        *ngIf="!localPreview && remoteUrl"
        [src]="remoteUrl"
        alt="Vista previa"
        class="uff__preview-img"
      />
      <div
        *ngIf="!localPreview && !remoteUrl"
        class="uff__preview-empty"
      >
        <mat-icon>description</mat-icon>
        <span>Archivo subido</span>
      </div>

      <!-- Overlay durante upload/confirm -->
      <div
        *ngIf="uploadState === 'uploading' || uploadState === 'confirming'"
        class="uff__overlay"
      >
        <mat-spinner diameter="36" color="accent"></mat-spinner>
        <span>{{ uploadState === 'uploading' ? 'Subiendo...' : 'Confirmando...' }}</span>
      </div>
    </div>

    <!-- Mensaje rechazo del operador -->
    <div *ngIf="item.status === 'REJECTED' && item.rejectReason" class="uff__reject">
      <mat-icon>info</mat-icon>
      <span>{{ item.rejectReason }}</span>
    </div>

    <!-- Mensaje "en revisión" — el cliente no tiene que hacer nada -->
    <div *ngIf="item.status === 'SUBMITTED' && uploadState === 'idle'" class="uff__hint">
      <mat-icon>hourglass_empty</mat-icon>
      <span>Estamos revisando este documento. No necesitás hacer nada.</span>
    </div>

    <!-- Mensaje "aprobado" — confirmación visual -->
    <div *ngIf="item.status === 'APPROVED'" class="uff__hint uff__hint--ok">
      <mat-icon>check_circle</mat-icon>
      <span>¡Listo! Este documento ya fue validado.</span>
    </div>

    <!-- Rotación de la imagen actual (solo para JPG/PNG/WEBP; PDF queda
         excluido en `canRotate`). Útil cuando el cliente toma la foto en
         orientación equivocada y no quiere volver a capturarla. -->
    <div *ngIf="canRotate" class="uff__rotate-group">
      <button
        type="button"
        class="uff__rotate-btn"
        (click)="rotate('ccw')"
        title="Rotar 90° a la izquierda"
      >
        <mat-icon>rotate_left</mat-icon>
        Rotar izquierda
      </button>
      <button
        type="button"
        class="uff__rotate-btn"
        (click)="rotate('cw')"
        title="Rotar 90° a la derecha"
      >
        <mat-icon>rotate_right</mat-icon>
        Rotar derecha
      </button>
    </div>

    <!-- Botones "reemplazar / retomar":
         - PENDING con archivo ya cargado → el cliente puede reemplazarlo antes de enviar.
         - REJECTED → el operador pidió reintento; mismo CTA con copy "otra".
         En SUBMITTED / APPROVED, `canUpload` es false → no se muestran. -->
    <div
      *ngIf="canUpload && showPreviewArea"
      class="uff__retry-group"
    >
      <button
        type="button"
        class="uff__retry-btn uff__retry-btn--camera"
        (click)="openCamera()"
      >
        <mat-icon>photo_camera</mat-icon>
        {{ item.status === 'REJECTED' ? 'Tomar otra foto' : 'Reemplazar con cámara' }}
      </button>
      <button
        type="button"
        class="uff__retry-btn"
        (click)="triggerRetryFileInput()"
      >
        <mat-icon>upload_file</mat-icon>
        {{ item.status === 'REJECTED' ? 'Subir desde archivo' : 'Reemplazar archivo' }}
      </button>
    </div>
    <!-- Input file oculto para el flujo de reemplazo — se dispara con
         .click() desde el botón. Fuera del <button> para HTML válido. -->
    <input
      #retryFileInput
      type="file"
      [accept]="acceptAttr"
      (change)="onFileSelected($event)"
      class="uff__file-input"
    />
  </div>

  <!-- Mensaje de error -->
  <div *ngIf="uploadState === 'error' && errorMessage" class="uff__error">
    <mat-icon>error_outline</mat-icon>
    <span>{{ errorMessage }}</span>
    <button type="button" class="uff__error-retry" (click)="retry()">
      <mat-icon>refresh</mat-icon> Reintentar
    </button>
  </div>

  <div *ngIf="errorMessage && uploadState === 'idle'" class="uff__error uff__error--inline">
    <mat-icon>error_outline</mat-icon>
    <span>{{ errorMessage }}</span>
  </div>

  <!-- Modal de captura con cámara del dispositivo. Misma lógica y
       configuración que el onboarding (frames, compresión, aspect ratio)
       para que el backend reciba imágenes con las mismas dimensiones
       que espera la validación server-side. -->
  <app-document-camera-capture
    [isOpen]="cameraOpen"
    [title]="cameraTitle"
    [subtitle]="cameraSubtitle"
    [frameAspectRatio]="cameraFrameAspectRatio"
    [frameShape]="cameraFrameShape"
    [preferredFacing]="cameraPreferredFacing"
    (captured)="onCameraCaptured($event)"
    (closed)="closeCamera()"
    (cameraError)="onCameraError($event)"
  ></app-document-camera-capture>
</div>
